

module.exports = __webpack_require__.stylable.create(
    "DishModalSpecialRequest389744783",
    {"classes":{"root":"DishModalSpecialRequest389744783__root","textArea":"DishModalSpecialRequest389744783__textArea","specialRequestTitle":"DishModalSpecialRequest389744783__specialRequestTitle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    15,
    "DishModalSpecialRequest389744783",
    null
);
